<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    class="drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :src="barImage"
    mobile-break-point="960"
    app
    width="260"
    v-bind="$attrs"
  >
    <template v-slot:img="props">
      <v-img
        :gradient="`to bottom, ${barColor}`"
        v-bind="props"
      />
    </template>

    <v-divider class="mb-1" />

    <v-list
      dense
      nav
    >
      <v-list-item>
        <v-list-item-avatar
          class="align-self-center"
          color="white"
          contain
        >
          <v-img
            src="../../../../assets/lotus-logo.svg"
            max-height="30"
          />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title
            class="display-1"
            v-text="profile.title"
          />
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider class="mb-2" />


      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->

    <v-list-item-group v-model="model" mandatory>
    <v-list-item  v-for="(item, i) in items"
                      :v-key="i"
                  @click="$router.replace(item.to).catch(()=>{})">
          <v-list-item-icon>
            <v-icon>{{item.icon}}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title style="cursor: pointer"
                               class="button-card"
                               v-text="item.title">
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
    </v-list-item-group>
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

    <div @click="logOut" style="cursor: pointer" class="log-out">
       <v-icon>mdi-logout</v-icon>
       <div style="margin-right: 10px">خروج از حساب کاربری</div>
    </div>
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import {
    mapState,
  } from 'vuex'
  import router from "../../../../router";

  export default {
    name: 'DashboardCoreDrawer',

    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      model: 0,
      items: [
        {
          title: 'صفحه اصلی',
          icon: 'mdi-view-dashboard ',
          to: '/mainPage/header',
        },
        {
          title: 'صفحه معرفی',
          icon: 'mdi-floor-plan',
          to: '/pages/IntroducePage',
        },
        {
          icon: 'mdi-office-building',
          title: 'واحد ها و امکانات',
          to: '/pages/features',
        },
        {
          title: 'اخبار',
          icon: 'mdi-email-newsletter',
          to: '/news',
        },
        {
          title: 'خرید و اجاره',
          icon: 'mdi-handshake-outline ',
          to: '/pages/rentAndBuy',
        },
        {
          title: 'فروشگاه‌ها',
          icon: 'mdi-cart-outline',
          to: '/shops',
        },
        {
          title: 'تماس با ما',
          icon: 'mdi-phone ',
          to: '/contact',
        },

      ],
      bool:true
    }),

    computed: {
      ...mapState(['barColor', 'barImage']),
      drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.$store.commit('SET_DRAWER', val)
        },
      },
      profile () {
        return {
          avatar: true,
          title: 'لوتوس مال'
        }
      },
    },

    methods: {
      logOut(){
        localStorage.setItem('lotusToken',null)
        router.push('/login').catch(()=>{})
      },
      checkChildren(item){
        this.bool = !!item.children
      }
    },
    mounted() {
      switch (this.$router.history._startLocation) {
        case '/mainPage/header':
             this.model = 0
              break
        case '/pages/IntroducePage':
          this.model = 1
          break

        case '/pages/features':
          this.model = 2
          break

        case '/news':
          this.model = 3
          break

        case '/pages/rentAndBuy':
          this.model = 4
          break

        case '/shops':
          this.model = 5
          break

        case '/contact':
          this.model = 6
          break


      }
    }
  }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
<style scoped>
  .demo-content .v-list-item{
    flex-direction: row-reverse;
    justify-content: flex-end;
  }
  .titleList{
    display: flex;
  }
  .fontListTitle{

  }
  .display-1{
    font-family:anjoman !important;
    font-weight: bold !important;
    font-size: 20px !important;
    line-height: 2rem !important;
  }
  .theme--dark.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: transparent;
  }
  .v-btn--contained {
    box-shadow: unset;
  }
  .button-card {
    margin-right: 6px;
    font-size: 0.8rem;
    font-weight: normal;
    font-family: anjoman;
    direction: rtl;
    background-color: transparent !important;
    color: white !important;
    margin-top: 0;
    border-radius: 0;
    margin-bottom: 0;
  }
  .log-out{
    display: flex;
    position: absolute;
    bottom: 10px;
    width: 100%;
    color: white;
    font-size: 15px;
    margin: 0 28px 0 auto;
  }
</style>
<style>

  .drawer .v-list-item--link::before{
    background-color: #e91e63;
  }
  .drawer .theme--dark.v-list-item--active:hover::before, .theme--dark.v-list-item--active::before {
    opacity: 0.24 !important;
  }
  .v-list-item__title{
    font-family:anjoman !important;
    font-size: 15px !important;
    line-height: 2rem !important;
  }
</style>
